import { UserWithRole } from "components/app-initialization/types";

export type CheckSuperAdmin<T extends UserWithRole> = {
  user: T;
};

const checkSuperAdmin = <T extends UserWithRole>({ user }: CheckSuperAdmin<T>): boolean => {
  return user.roles.some((role) => role?.role?.Role === "SUPER ADMIN");
};

export default checkSuperAdmin;
